import { render } from "./DefaultCardMobile.vue?vue&type=template&id=79185675&scoped=true&ts=true"
import script from "./DefaultCardMobile.vue?vue&type=script&lang=ts"
export * from "./DefaultCardMobile.vue?vue&type=script&lang=ts"

import "./card.scss?vue&type=style&index=0&id=79185675&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79185675"]])

export default __exports__